import { getLocalStorage } from '@bingads-webui/storage';

export const LINKEDIN_CAMPAIGN_OBJECTIVES = {
  Consideration: 'Consideration',
  Awareness: 'Awareness',
};

export const LINKEDIN_CAMPAIGN_GOALS = {
  MoreWebsiteActions: 'MoreWebsiteActions',
  MoreBrandAwareness: 'MoreBrandAwareness',
};

export const getCampaignObjective = () => {
  const localStorage = getLocalStorage();
  let campaignObjective = LINKEDIN_CAMPAIGN_OBJECTIVES.Consideration;

  if (localStorage.supportsStorage()) {
    campaignObjective = localStorage.get('CampaignObjective');
  }

  return campaignObjective;
};

export const getLinkedInCampaignGoal = () => {
  const objective = getCampaignObjective();
  switch (objective) {
    case LINKEDIN_CAMPAIGN_OBJECTIVES.Consideration:
      return LINKEDIN_CAMPAIGN_GOALS.MoreWebsiteActions;
    case LINKEDIN_CAMPAIGN_OBJECTIVES.Awareness:
      return LINKEDIN_CAMPAIGN_GOALS.MoreBrandAwareness;
    default:
      return LINKEDIN_CAMPAIGN_GOALS.MoreWebsiteActions;
  }
};

export const getLinkedInBidStrategyOptions = (campaignGoal) => {
  if (campaignGoal === LINKEDIN_CAMPAIGN_GOALS.MoreBrandAwareness) {
    return [{
      key: 'MaxReach',
      text: _TL_('Maximize reach'),
    }, {
      key: 'MaxImpressions',
      text: _TL_('Maximize impressions'),
    }];
  }

  return [{
    key: 'MaxClicks',
    text: _TL_('Maximize clicks'),
  }];
};
